module.exports = __webpack_public_path__ + "static/media/ribbon-specialoffer-de@3x.770bb5e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ribbon-specialoffer-de@3x.png
// module id = 306
// module chunks = 0